import * as React from "react";
import {feature} from "../Menu/ToggleButton/FeatureToggle";
import {details} from "../Menu/DetailButton/DetailToggle";
import {ModelControler} from "../../service/modelController";
import './startup.css'
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { PriceService } from '../../service/PriceService';

interface StartupProps {
    onChangeProduct:()=>Promise<void>
    startMenuOn:boolean
    closeStartMenu:()=>void
}

interface StartupState {
    active:boolean;
    isLoading:boolean;
}

export class Startup extends React.Component<StartupProps, StartupState>{
    constructor(props:StartupProps) {
        super(props);
        this.state = {
            active:true,
            isLoading:false
        };
    }

    componentDidMount(){
    }


    public turnOn(){
        this.setState({
            active:true
        })
    }

    render(){
            if(this.props.startMenuOn){
                return(
                    <div id="startup-id" className="startup" draggable={false}>
                    <div id="white-background"></div>
                    <div className={"loader " + (this.state.isLoading? "":"hide")} ></div>

                        <div id="startup-header">
                            <div className="startup-content underlined">
                                <a href="https://www.schickling-grill.de/" target="_blank">
                                    <img src={require("../../img/logo-schickling-grill-1.png")} alt="" draggable={false}/>
                                </a>
                            </div>
                        </div>
                        <div id="startup-main">
                            <div className="startup-content">
                            <PerfectScrollbar>
                                <div id="startup-headline">
                                    <h1>ERLEBE DIE FREUDE AM GRILLEN.</h1>
                                    <span>Konfiguriere jetzt deinen Traumgrill</span>
                                </div>

                                <div id="startup-grill-wrapper">
                                    <div className="startup-selection-wrapper">
                                        <div className="startup-img-wrapper">
                                            <img src={require("../../img/hn.png")} alt="" draggable={false}/>
                                        </div>
                                        <div className="startup-button" onClick={this.changeProduct.bind(this, 0)}>
                                            <span>JETZT KONFIGURIEREN</span>
                                        </div>
                                    </div>

                                    <div className="startup-selection-wrapper">
                                        <div className="startup-img-wrapper">
                                            <img src={require("../../img/hnxl.png")} alt="" draggable={false}/>
                                        </div>
                                        <div className="startup-button" onClick={this.changeProduct.bind(this, 1)}>
                                            <span>JETZT KONFIGURIEREN</span>
                                        </div>
                                    </div>
                                </div>
                                </PerfectScrollbar>
                            </div>
                        </div>
                        <div id="startup-footer">
                            <div className="startup-content overlined">
                                <img src={require("../../img/made-in-germany-gravur.png")} alt="" draggable={false}/>
                                <img src={require("../../img/made-with-love.png")} alt="" draggable={false}/>
                                <img src={require("../../img/direkt-vom-hersteller.png")} alt="" draggable={false}/>
                            </div>
                        </div>
                    </div>
                )
            }
            else{
                return null;
            }
    }




    changeProduct(index:number){
        this.setState({isLoading:true});
        if(ModelControler.instance.setCurrentProduct(index)){
            this.props.onChangeProduct().then(()=>{
                PriceService.instance.getAllProductPrice().then(()=>{
                    this.setState({isLoading:false});
                    this.props.closeStartMenu();
                })
            });
        }
        else{
            this.setState({isLoading:false});
            this.props.closeStartMenu();
        }
    }
}